import useCasMutation, {
  IGenericMutationProps,
} from 'src/compass/shared/hooks/reactQuery/useCasMutation';

type uploadMutationProps = IGenericMutationProps & {
  url: string;
};

export default function useDeleteMutation({ url, ...rest }: uploadMutationProps) {
  return useCasMutation({ method: 'delete', url, ...rest });
}
